export interface AccreditationLicense {
  content: string;
  link?: string;
}

export const UNION_CITY_LICENSES: AccreditationLicense[] = [
  {
    content: "CA: CDF-00353741",
    link: "https://cdn.prod.website-files.com/6880c9300eb95bb084b75b2e/68b7246f40147a43b64a96cf_CDPH-UC-License-Certificate-2025.pdf",
  },
  {
    content: "CAP: 8643216",
    link: "https://cdn.prod.website-files.com/6880c9300eb95bb084b75b2e/69fa0df14dabb26e60279c1f_CAP%20Accreditation%20Certificate%202026.pdf",
  },
  {
    content: "CLIA: 05D2167800",
    link: "https://cdn.prod.website-files.com/6880c9300eb95bb084b75b2e/6a343b9f3887242da9f81c4c_CLIA-Certificate-05D2167800-2026-06-14%20(1).pdf",
  },
  {
    content: "MD: 2999",
    link: "https://cdn.prod.website-files.com/6880c9300eb95bb084b75b2e/68b7250f99976ab222972cc8_CLIA-Prenatal-MD-License-Name_-MD_2999.pdf",
  },
  {
    content: "PA: 37021",
    link: "https://cdn.prod.website-files.com/6880c9300eb95bb084b75b2e/692f38f6144b2efd0b6dd818_PA%203200%20Whipple%202025-2026.pdf",
  },
  {
    content: "RI: LCO01671",
    link: "https://cdn.prod.website-files.com/6880c9300eb95bb084b75b2e/68b725a985a6cdf7061b45f5_CLIA-Prenatal-RI-License-Name_-RI_-LCO01671.pdf",
  },
  {
    content: "DC: HFD-OS29",
    link: "https://cdn.prod.website-files.com/6880c9300eb95bb084b75b2e/692f38f64ca3fe4cb32ecff8_DC%20Prenatal%202025-2027.pdf",
  },
  {
    content: "NYSDOH: 9828",
    link: "https://cdn.prod.website-files.com/6880c9300eb95bb084b75b2e/692f38f675a7404faf8472d3_2025%20NYS%20Prenatal%20Permit%20(1).pdf",
  },
];

export const MENLO_PARK_LICENSES: AccreditationLicense[] = [
  {
    content: "CA: CDF-90008579",
    link: "https://cdn.prod.website-files.com/6880c9300eb95bb084b75b2e/68b72678bc1ccd433b9beec9_CLIA-Oncology-CA-License-Name_-CA_CDF-90008579.pdf",
  },
  {
    content: "CAP: 9568790",
    link: "https://cdn.prod.website-files.com/6880c9300eb95bb084b75b2e/68b726b12aee60052cf9a50a_CLIA-Oncology-CAP-Accreditation-Certificate-Name_-CAP_9568790.pdf",
  },
  {
    content: "CLIA: 05D2275351",
    link: "https://cdn.prod.website-files.com/6880c9300eb95bb084b75b2e/691c7b47dc59cb1577f8ae8c_2025-2027%20Oncology%20CLIA%20CoA.pdf",
  },
  {
    content: "MD: 3855",
    link: "https://cdn.prod.website-files.com/6880c9300eb95bb084b75b2e/68b727feaf11c15b64d56546_CLIA-Oncology-MD-License-Name_-MD_3855.pdf",
  },
  {
    content: "PA: 40795",
    link: "https://cdn.prod.website-files.com/6880c9300eb95bb084b75b2e/691c7b47ece9a3368cb6d83c_PA%20-%2040795%20(2025-2026)%20License.pdf",
  },
  {
    content: "RI: LCO01700",
    link: "https://cdn.prod.website-files.com/6880c9300eb95bb084b75b2e/68b72840c50d84cebd4cde7d_CLIA-Oncology-RI-License-Name_-RI_LCO01700.pdf",
  },
  {
    content: "DC: HFD-OS43",
    link: "https://cdn.prod.website-files.com/6880c9300eb95bb084b75b2e/68b728725d595cb9065ccd54_CLIA-Oncology-DC-License-Name_-DC_HFD-OS43.pdf",
  },
];
